import classNames from 'classnames';
import type React from 'react';

import type { SkeletonProps } from './types';
import './skeleton.scss';

export const Skeleton: React.FC<SkeletonProps> = ({
  shape = 'rectangle',
  rounded = true,
  height,
  width,
  className,
  ariaBusy = true,
  ariaLabel = 'Loading...',
  ...props
}) => {
  const skeletonClasses = classNames(
    'skeleton-payflow-ui',
    {
      'skeleton-payflow-ui--rounded': rounded,
      'skeleton-payflow-ui--circle': shape === 'circle',
      'skeleton-payflow-ui--rectangle': shape === 'rectangle',
      'skeleton-payflow-ui--square': shape === 'square',
    },
    className
  );

  const style: React.CSSProperties = {};

  if (height) {
    style.height = typeof height === 'number' ? `${height}px` : height;
  }

  if (width) {
    style.width = typeof width === 'number' ? `${width}px` : width;
  }

  return (
    <div
      role="status"
      aria-live="polite"
      aria-busy={ariaBusy}
      aria-label={ariaLabel}
      className={skeletonClasses}
      style={style}
      {...props}
    />
  );
};
